module.exports = __webpack_public_path__ + "img/92172.46dec431.svg";